import { Link } from 'react-router-dom';

export default () => {
	return (
		<div className='flex flex-row gap-5 place-items-center justify-center p-2'>
			<span className='text-nowrap'>©2024 cadenmarinozzi</span>
			<Link to='/admin'>Login</Link>
		</div>
	);
};
